import React, { useState } from 'react';

import { Grid, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  square: {
    borderStyle: 'solid',
    borderWidth: 1,
    height: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    width: theme.spacing(2),
  },
  squaresPanel: {
    padding: theme.spacing(2, 1.5, 1, 2),
  },
}));

interface TableSquaresProps {
  insertTable: (rowCount: number, columnCount: number) => void;
  columns?: number;
  rows?: number;
}

export function TableSquares({
  columns = 10,
  insertTable,
  rows = 10,
}: TableSquaresProps): JSX.Element {
  const { classes } = useStyles();
  const [rowCount, setRowCount] = useState<number>(0);
  const [columnCount, setColumnCount] = useState<number>(0);

  const squares = [];
  for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
    const rowSquares = [];
    for (let columnIndex = 0; columnIndex < columns; columnIndex++) {
      rowSquares.push(
        <TableSquare
          key={columnIndex}
          columnCount={columnCount}
          columnIndex={columnIndex}
          insertTable={insertTable}
          rowCount={rowCount}
          rowIndex={rowIndex}
          setColumnCount={setColumnCount}
          setRowCount={setRowCount}
        />
      );
    }
    squares.push(
      <Grid key={rowIndex} container>
        {...rowSquares}
      </Grid>
    );
  }

  return (
    <div className={classes.squaresPanel}>
      <Grid
        container
        sx={{ flexDirection: 'column' }}
        onClick={() => {
          insertTable(rowCount, columnCount);
        }}
        onMouseLeave={() => {
          setRowCount(0);
          setColumnCount(0);
        }}
      >
        {...squares}
      </Grid>
      <Typography align="center">{`${rowCount} x ${columnCount}`}</Typography>
    </div>
  );
}

interface TableSquareProps {
  columnCount: number;
  columnIndex: number;
  insertTable: (rowCount: number, columnCount: number) => void;
  rowCount: number;
  rowIndex: number;
  setColumnCount: (columns: number) => void;
  setRowCount: (rows: number) => void;
}

function TableSquare({
  columnCount,
  columnIndex,
  insertTable,
  rowCount,
  rowIndex,
  setColumnCount,
  setRowCount,
}: TableSquareProps): JSX.Element {
  const { classes } = useStyles();
  const theme = useTheme();
  const selected = columnCount > columnIndex && rowCount > rowIndex;

  return (
    <Grid
      className={classes.square}
      style={{
        background: selected
          ? theme.appColors.hoverBackground
          : theme.appColors.defaultFieldBackground,
        borderColor: selected ? theme.appColors.primary : theme.appColors.rule,
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        // Stop propagation to avoid calling insertTable on the parent and inserting a table w/in a table.
        e.stopPropagation();
        insertTable(rowCount, columnCount);
      }}
      onMouseEnter={() => {
        setColumnCount(columnIndex + 1);
        setRowCount(rowIndex + 1);
      }}
    ></Grid>
  );
}
